var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 42,
    viewBox: "0 0 101 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_401_18644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.3164,
    y: 5.74645,
    width: 75.0397,
    height: 26.8435,
    rx: 13.4217,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9082 19.2473L29.478 13.6775L30.3408 14.5403L24.771 20.1101L23.9082 19.2473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9082 19.2473L29.478 13.6775L30.3408 14.5403L24.771 20.1101L23.9082 19.2473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9082 19.2473L29.478 13.6775L30.3408 14.5403L24.771 20.1101L23.9082 19.2473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9082 19.2473L29.478 13.6775L30.3408 14.5403L24.771 20.1101L23.9082 19.2473Z",
    fill: "#5CBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.478 13.6775L29.6937 13.4618L29.478 13.2461L29.2623 13.4618L29.478 13.6775ZM23.9082 19.2473L23.6925 19.0316L23.4768 19.2473L23.6925 19.463L23.9082 19.2473ZM30.3408 14.5403L30.5565 14.756L30.7722 14.5403L30.5565 14.3246L30.3408 14.5403ZM24.771 20.1101L24.5553 20.3258L24.771 20.5415L24.9867 20.3258L24.771 20.1101ZM29.2623 13.4618L23.6925 19.0316L24.1239 19.463L29.6937 13.8932L29.2623 13.4618ZM30.5565 14.3246L29.6937 13.4618L29.2623 13.8932L30.1251 14.756L30.5565 14.3246ZM24.9867 20.3258L30.5565 14.756L30.1251 14.3246L24.5553 19.8944L24.9867 20.3258ZM23.6925 19.463L24.5553 20.3258L24.9867 19.8944L24.1239 19.0316L23.6925 19.463Z",
    fill: "#5CBC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.771 18.7303L30.3408 24.3001L29.478 25.1629L23.9082 19.5931L24.771 18.7303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.771 18.7303L30.3408 24.3001L29.478 25.1629L23.9082 19.5931L24.771 18.7303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.771 18.7303L30.3408 24.3001L29.478 25.1629L23.9082 19.5931L24.771 18.7303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.771 18.7303L30.3408 24.3001L29.478 25.1629L23.9082 19.5931L24.771 18.7303Z",
    fill: "#5CBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3408 24.3001L30.5565 24.5158L30.7722 24.3001L30.5565 24.0844L30.3408 24.3001ZM24.771 18.7303L24.9867 18.5146L24.771 18.2989L24.5553 18.5146L24.771 18.7303ZM29.478 25.1629L29.2623 25.3786L29.478 25.5943L29.6937 25.3786L29.478 25.1629ZM23.9082 19.5931L23.6925 19.3774L23.4768 19.5931L23.6925 19.8088L23.9082 19.5931ZM30.5565 24.0844L24.9867 18.5146L24.5553 18.946L30.1251 24.5158L30.5565 24.0844ZM29.6937 25.3786L30.5565 24.5158L30.1251 24.0844L29.2623 24.9472L29.6937 25.3786ZM23.6925 19.8088L29.2623 25.3786L29.6937 24.9472L24.1239 19.3774L23.6925 19.8088ZM24.5553 18.5146L23.6925 19.3774L24.1239 19.8088L24.9867 18.946L24.5553 18.5146Z",
    fill: "#5CBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9033 17.5052L49.5167 17.5052C49.8241 18.2958 50.2341 19.0133 50.7466 19.6429C51.2298 19.0133 51.6104 18.2958 51.9033 17.5052ZM52.9136 15.9092L54.0264 16.2606C53.631 18.1494 52.9282 19.6722 51.9911 20.8582C52.8111 21.4878 53.7774 21.9563 54.9342 22.2638C54.5535 22.6006 54.0556 23.3034 53.8214 23.7719C52.6207 23.3912 51.6251 22.8348 50.7759 22.1174C49.9706 22.7909 49.0481 23.318 48.0232 23.728C47.8182 23.2887 47.3789 22.6006 47.0422 22.2638C47.9793 21.9563 48.8431 21.4731 49.5752 20.8582C48.8871 19.965 48.3453 18.9254 47.9353 17.7248C47.8182 19.6283 47.4375 21.8831 46.2515 23.4351C45.944 23.1423 45.1973 22.6591 44.7873 22.4981C46.1637 20.7557 46.2954 18.208 46.2954 16.3631L46.2954 12.9662L54.3485 12.9662L54.3485 14.5914L47.9646 14.5914L47.9646 15.9531L52.5915 15.9531L52.9136 15.9092ZM45.1241 14.9721L43.7331 16.1142C43.3085 15.426 42.2836 14.4304 41.4343 13.7715L42.7375 12.7319C43.5867 13.3615 44.6409 14.284 45.1241 14.9721ZM44.7434 18.0762L44.7434 22.6738C45.3584 23.6548 46.4711 24.0501 48.0085 24.1087C49.7216 24.1819 53.0454 24.138 54.9927 23.9915C54.7877 24.4015 54.5242 25.2507 54.451 25.7486C52.6793 25.8364 49.7363 25.8657 47.9793 25.7925C46.1637 25.7193 44.9484 25.3093 43.9967 24.1672C43.3671 24.7383 42.7375 25.3093 41.9614 25.9243L41.1122 24.1087C41.6979 23.7573 42.4153 23.2594 43.0449 22.7616L43.0449 19.6722L41.4343 19.6722L41.4343 18.0762L44.7434 18.0762ZM66.8234 20.4482L66.8234 17.9152L64.2464 17.9152L64.2464 20.4482L66.8234 20.4482ZM62.6065 16.3924L68.5804 16.3924L68.5804 21.9563L62.6065 21.9563L62.6065 16.3924ZM61.2009 23.6548L70.0007 23.6548L70.0007 14.6647L61.2009 14.6647L61.2009 23.6548ZM59.3853 12.8783L71.9041 12.8783L71.9041 26.056L70.0007 26.056L70.0007 25.28L61.2009 25.28L61.2009 26.056L59.3853 26.056L59.3853 12.8783Z",
    fill: "#5CBC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_401_18644",
    x: -2.32508,
    y: 0.255737,
    width: 104.933,
    height: 46.366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.44031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.22016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_401_18644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_401_18644",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.3e5e55538862226ccde35a8824456149.svg";
export { ForwardRef as ReactComponent };